import FacebookProductSetCards from '../../components/Facebook/FacebookProductSetCards';
import ListingPage from '../../components/ListingPage';

const FacebookProductSetPage = () => {
  return (
    <ListingPage
      createRestrictionKey="facebookProductSetsCreate"
      entityType="facebookProductSet"
      useStats={false}
      filterBy="name"
      Cards={FacebookProductSetCards}
    />
  );
};

export default FacebookProductSetPage;
